import { Button, InputAdornment, inputClasses } from '@mui/material';
import { createPlanPageHeaderSelectors, getSelectorAttribute } from '@weft/app-selectors';
import { isNotNullOrUndefined, withDefault } from '@weft/utils';
import { get } from 'lodash';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { VayuTextField } from '../../../../components/design/vayu-theme-components/VayuTextField';
import { EditIcon } from '../../../../components/icons';
import { ArrowIcon } from '../../../../components/icons/ArrowIcon';
import { ARROW_ICON_DIRECTIONS } from '../../../../components/icons/ArrowIcon/types/arrow-icon-direction';
import { HelpIcon } from '../../../../components/icons/HelpIcon';
import { useCreatePlanContext } from '../../../../contexts/create-plan-context';
import { useFormErrorNotificationContext } from '../../../../contexts/form-error-notification-context/form-error-notification-context';
import { useVyNavigate } from '../../../../hooks/use-vy-navigate';
import type { NewPlanForm } from './CreatePlanForm/create-plan-form-types/new-plan-form';
import type { PlanInputForm } from './CreatePlanForm/create-plan-form-types/plan-input-form';
import type { CreatePlanTab } from './CreatePlanPageTabs/create-plan-page-types/create-plan-tab';

export const CreatePlanPageHeader: React.FC = () => {
  const { planCreationStepper: { currentStep, previousStep } } = useCreatePlanContext();
  const { registerErrorField } = useFormErrorNotificationContext<PlanInputForm, CreatePlanTab>();
  const { setFocus, register, getValues, formState: { errors } } = useFormContext<PlanInputForm, NewPlanForm>();
  const nameRegister = register('name');
  const navigate = useVyNavigate();

  registerErrorField(nameRegister.name);

  const handleGoBack = () => {
    if (currentStep === 0) {
      navigate('/plans');

      return;
    }
    
    previousStep();
  };

  return (
    <header className="border-b-disabled relative flex items-center justify-between border-b p-4">
      <Button
        className="gap-x-2"
        size="medium"
        onClick={handleGoBack}
      >
        <ArrowIcon direction={ARROW_ICON_DIRECTIONS.LEFT} />
        <span>Go Back</span>
      </Button>

      <VayuTextField
        {...getSelectorAttribute(createPlanPageHeaderSelectors.planNameInput)}
        placeholder="Plan name"
        size="small"
        sx={{
          [`& .${inputClasses.root}`]: {
            '&.Mui-focused': {
              paddingRight: '16px !important',
            },
          },
          maxWidth: '280px',
        }}
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment
              position="start"
              sx={{
                paddingBottom: '4px',
                paddingLeft: '8px',
              }}
              onClick={() => setFocus('name')}
            >
              <EditIcon className="fill-[#C3CED2]"/>
            </InputAdornment>
          ),
        }}
        error={isNotNullOrUndefined(get(errors, nameRegister.name))}
        value={withDefault(getValues(nameRegister.name), '')}
        {...nameRegister}
      />

      <Button
        className="gap-x-2"
        size="medium"
        disabled
      >
        <HelpIcon/>
        <span>Help</span>
      </Button>
    </header>
  );
};
